module.exports = __webpack_public_path__ + "img/icon.3a0ea12b.svg";